export const TEST_ID = 'chemicalMixSelectPanelField';
